import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const NotionSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [workspaceName, setWorkspaceName] = useState<string>("your workspace");
  
  useEffect(() => {
    // Get params from the URL
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const name = params.get("workspace_name");
    
    if (name) {
      setWorkspaceName(name);
    }
    
    // If we received a new token for the Notion integration, store it
    if (token) {
      try {
        // Store the notion integration token (you might want to handle this differently)
        localStorage.setItem("notion_token", token);
        toast.success("Notion integration successfully connected!");
      } catch (error) {
        console.error("Error storing Notion token:", error);
      }
    }
    
    // Scroll to top
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-6">
      <motion.div 
        className="max-w-md w-full mx-auto text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="mb-8 flex justify-center">
          <div className="rounded-full bg-primary/20 p-3 text-primary">
            <Check className="h-8 w-8" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
          Successfully Connected to Notion
        </h1>
        
        <p className="text-gray-400 mb-8">
          Your DocGen account is now connected to <span className="font-medium text-white">{workspaceName}</span>. 
          You can now export your documentation directly to Notion pages.
        </p>
        
        <div className="space-y-4">
          <Button 
            className="w-full bg-gradient-to-r from-primary to-blue-500 text-background hover:opacity-90 transition-all duration-300"
            onClick={() => navigate("/integrations")}
          >
            <span className="flex items-center">
              Return to Integrations
              <ArrowRight className="ml-2 h-4 w-4" />
            </span>
          </Button>
          
          <Button 
            variant="ghost" 
            className="w-full text-gray-400 hover:text-white"
            onClick={() => navigate("/dashboard")}
          >
            Go to Dashboard
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotionSuccess; 